import type { Props } from './Svg'
import { Svg } from './Svg'

export function ChevronDownIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path strokeWidth="2" d="m4.5 6.75 4.5 4.5 4.5-4.5" />
    </Svg>
  )
}
